import Steper from "../../../../components/steper/steper";

const SteperNewProfile = ({ current = 0 }) => {
  return (
    <>
      <Steper
        currrent={current}
        items={[{ title: "اطلاعات هویتی" }, { title: "اطلاعات تماس" }, { title: "اطلاعات بانکی" }, { title: "بررسی و تایید" }]}
      />
    </>
  );
};

export default SteperNewProfile;
